import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const fetchUserOrgMembersTE = <E = CF.API.ApiError>(
  { orgId }: { orgId: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Organizations.ListUserOrgMembersResponse> =>
  fetchTE<CF.API.Organizations.ListUserOrgMembersResponse, E>(
    {
      path: `/api/_api/v2/organizations/${orgId}/members`,
    },
    onRejected,
  );
